import PropTypes from "prop-types";
import React from "react";

const style = {
  boxSizing: "border-box",
  display: "block",
  height: "auto",
  width: "100%",
};

const Photo = ({ url }) => <img css={style} src={url} />;

Photo.propTypes = {
  url: PropTypes.string.isRequired,
};

export default Photo;
